<template>
  <div class="app__nav__container">
    <nav class="app__nav">
      <div class="relative d-flex justify-content-between">
        <div class="app__nav--active app__nav--active--main"></div>

        <router-link
          :to="toAccount"
          class="nav__option"
          data-class-target="app__nav--active--1"
          data-step="2"
        >
          <div class="nav__option__icon">
            <i class="fas fa-user"></i>
            <small class="nav__option__name">Mi cuenta</small>
          </div>
        </router-link>
        <router-link
          :to="toHome"
          class="nav__option nav__option--active"
          data-class-target="app__nav--active--main"
          data-step="1"
        >
          <div class="nav__option__icon">
            <i class="fas fa-shield-alt"></i>
            <small class="nav__option__name">Asegurar</small>
          </div>
        </router-link>
        <router-link
          :to="toHistory"
          class="nav__option"
          data-class-target="app__nav--active--3"
          data-step="3"
        >
          <div class="nav__option__icon">
            <i class="fas fa-history"></i>
            <small class="nav__option__name">Historial</small>
          </div>
        </router-link>

      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      token: null,
      id: null
    }
  },
  methods: {
    handleNav(step, e) {
      let item = e.target;
      if (
        item.classList.contains("fas") ||
        item.classList.contains("nav__option__name")
      ) {
        item = item.parentElement;
      }

      const targetClass = item.getAttribute("data-class-target") ? item.getAttribute("data-class-target") : item.parentElement.getAttribute("data-class-target");
      const bubble = document.querySelector(".app__nav--active");

      bubble.classList.remove("app__nav--active--main");
      bubble.classList.remove("app__nav--active--1");
      bubble.classList.remove("app__nav--active--3");
      bubble.classList.add(targetClass);

      item.parentElement.parentElement
        .querySelector(".nav__option--active")
        .classList.remove("nav__option--active");
      item.classList.add("nav__option--active");

      this.$emit("setPage", step);
    },
  },
  computed: {
    toAccount() {
      return {
        path: '/pages/app/account',
        query: { token: this.token, id: this.id }
      }
    },
    toHome() {
      return {
        path: '/pages/app',
        query: { token: this.token, id: this.id }
      }
    },
    toHistory() {
      return {
        path: '/pages/app/history',
        query: { token: this.token, id: this.id }
      }
    }

  },
  created() {
    const { token, id } = this.$route.query;
    this.token = token;
    this.id = id;
  }
};
</script>

<style lang="scss">
.app__nav__container {
  position: fixed;
  bottom: 10px;
  left: 0;
  width: 100%;
}

.nav__option__name {
  display: block;
  line-height: 1.2;
  margin-top: 3px;
}

.app__nav {
  width: calc(100% - 20px);
  max-width: 500px;
  border-radius: 40px;
  height: 50x;
  margin: 0 auto;
  background-color: #e7e7ea;
  box-shadow: 0 0 20px rgba(126, 126, 126, 0.8);
  padding: 10px 0;
  position: relative;
}
.nav__option {
  color: #003c71;
  text-decoration: none;
  width: 33.3%;
  text-align: center;
  position: relative;
  z-index: 5;
  &:hover {
    text-decoration: none;
  }
  i {
    display: block;
    font-size: 18px;
  }
}
.nav__option--active {
  color: white;
}

.app__nav--active {
  background-color: #003c71;
  background: linear-gradient(to bottom, #003c71, #085da8);
  width: 60px;
  height: 60px;
  position: absolute;
  border-radius: 50%;
  bottom: -13px;
  transition: all 0.3s ease;
}
.app__nav--active--main {
  left: calc(50% - 30px);
}
.app__nav--active--3 {
  left: calc(83.55% - 30px) !important;
}
.app__nav--active--1 {
  left: calc(16.65% - 30px) !important;
}

@media only screen and (max-height: 400px) and (max-width: 720px) {
  .app__nav__container {
    display: none;
  }
}

@media only screen and (min-width: 1140px) {
  .app__nav__container {
    top: 0;
    left: 10px;
    height: 100%;
    width: 75px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .app__nav {
    height: calc(100% - 20px);
    max-height: 500px;
    width: 50px;
    margin: 0 auto;
    position: relative;

    & > div {
      flex-direction: column;
      align-items: center;
      height: 100%;
    }
  }

  .nav__option {
    width: 100%;
    height: 33.3%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .app__nav--active--main {
    top: calc(50% - 30px);
  }
  .app__nav--active--3 {
    top: calc(83.55% - 30px)!important;
    left: -5px!important;
  }
  .app__nav--active--1 {
    top: calc(16.65% - 30px) !important;
    left: -5px!important;
  }
}
</style>